import { Component } from 'react';



class RedirectPage extends Component {
    componentDidMount() {
        window.location.href = 'https://nbcfonline.com/';
    }
    
    render() {
        return null; // renders nothing
    }
}
export default RedirectPage;